import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import clsx from 'clsx';
import { useMemo, useRef, useState } from 'react';
import { useOnClickOutside } from '../../hook/useOnClickOutside';
import style from './style.module.scss';

export const InputSelect = ({ title, value, fieldName, onChange, options, init, points }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const ref = useRef();

    const filteredOptions = useMemo(
        () => options.filter((option) => option.toLowerCase().includes(search.toLowerCase())),
        [options, search],
    );

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const closeDropdownAndSelectFirstChoice = () => {
        setOpen(false); // close the dropdown
        const firstMatchingOption = filteredOptions[0]; // select the first choice by default
        // Check the search value is different than '', is not already in options, and is similar than an option
        if (search && !options.includes(search) && firstMatchingOption) {
            setSearch(firstMatchingOption);
            onChange(firstMatchingOption, fieldName);
        } else {
            setSearch('');
        }
    };

    const handleKeyEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            closeDropdownAndSelectFirstChoice();
        } else if (e.key === 'Tab') {
            closeDropdownAndSelectFirstChoice();
        }
    };

    useOnClickOutside(ref, () => {
        // closeDropdownAndSelectFirstChoice();
        setOpen(false);
        setSearch('');
    });

    return (
        <div className={clsx(style.block, style.disabled)}>
            <div className={style.top}>
                <div>{title}</div>

                {points !== null &&
                    (init ? (
                        <div className={style.points} style={{ color: style.green }}>{`✓ ${points} points`}</div>
                    ) : (
                        <div className={style.points}>(+{points} points)</div>
                    ))}
            </div>

            <div ref={ref} className={style.selectContainer}>
                <div className={style.select}>
                    <input
                        value={search || value}
                        className={style.current}
                        onChange={(e) => handleSearchChange(e)}
                        // onBlur={() => closeDropdownAndSelectFirstChoice()}
                        onClick={() => setOpen(true)}
                        onFocus={() => setOpen(true)}
                        onKeyDown={handleKeyEnter}
                    />

                    <div className={style.arrowContainer}>
                        <ArrowBackIosRoundedIcon className={clsx(style.svg, open && style.revertArrow)} />
                    </div>
                </div>

                <div className={open ? style.open : style.hide}>
                    {filteredOptions.map((elem, i) => (
                        <div
                            key={elem}
                            className={clsx(style.options, value === elem && style.hideOptions)}
                            onClick={() => {
                                setSearch('');
                                onChange(elem, fieldName);
                                setOpen(false);
                            }}
                        >
                            {elem}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
